const DATATYPE_TEF = {
  ALPHANUMERIC: 0,
  NUMERIC: 1,
  CURRENCY: 2,
  INFORMATION: 3,
  CONFIRMATION: 4,
  AWAIT: 5,
  MENU: 6,
  QRCODE: 7,
};

const stringsParaCancelamento = [
  "SOLICITE A SENHA",
  "Aproxime, insira ou passe o cartao na leitora",
];

const stringFinalizacaoRotinaTef = "Retire o cartao da leitora";

const stringsErroMensagemTef = [
  "cancelada",
  "falha",
  "erro",
  "sem comunicação",
];

const stringsSucessoMensagemTef = ["ativo"];

export {
  DATATYPE_TEF,
  stringsParaCancelamento,
  stringFinalizacaoRotinaTef,
  stringsErroMensagemTef,
  stringsSucessoMensagemTef
};
